// @flow

import React from 'react';
import View from 'components/authentication/sign_up/View';
import { Auth, HeaderIcons } from 'utils/ExportCommon';
import { Wrapper, Container, LeftSide, RightSide } from 'styles/auth/style';
import { Link, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { media } from 'styles/Mixins';
import HomieContext from 'HomieContext';
import queryString from 'query-string';
import HomeApplicationActions from 'actions/HomeApplicationActions';
import HomeApplicationStore from 'stores/HomeApplicationStore';
import CampaignActions from 'actions/CampaignActions';
import CurrentUser from 'actions/CurrentUserActions';
const DivLabel = styled.div`
  text-align: center;
`;

const StyledLeftSide = styled(LeftSide)`
  display: flex;
  flex-direction: column;
`;

const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: calc(100vh - 62px);
  ${media.md`
    min-height: calc(100vh - 142px);
  `}
`;

const Label = styled.label`
  font-size: 16px;
  height: 24px;
  color: #4a4a4a;
  line-height: 24px;
  font-weight: 500;
  margin-bottom: 20px;
`;

const StyledLink = styled(Link)`
  width: 182px;
  color: #278c7e;
  font-size: 16px;
  &:hover {
    color: #278c7e;
  }
`;

const StyledWrapper = styled(Wrapper)`
  padding-top: ${props => (props.isPadding ? '60px' : '50px 0')};
`;

const WrapperLogo = styled.div`
  display: flex;
  top: 0;
  left: 0;
  margin: 0 auto;
  z-index: 100;
  min-height: 60px;
  background-color: #ffffff;
  border-bottom: 1px solid #babed7;
  width: 100%;
  align-items: center;
  position: fixed;
  margin-bottom: 25px;
`;

const ContainerLogo = styled.div`
  padding: 0 10px;
  ${media.md`
    width: 1024px;
    padding: 0 75px;
    text-align: left;
    margin: 0 auto;
  `}
`;

const Logo = styled(HeaderIcons.LogoSVG)`
  height: 35px;
  width: 90px;
  vertical-align: middle;
  ${media.md`
    height: 32px;
    width: 94px;
  `};
`;

type PropsType = {
  status: boolean,
  location: any,
  history: any
};

type StateType = {
  typeUserSelected: any,
  toWelcome: boolean,
  campaign: string,
  accepted_home_publishing_agreement: boolean,
  user_id: string
};

class Index extends React.Component<PropsType, StateType> {
  constructor(props: PropsType) {
    super(props);
    this.state = {
      typeUserSelected: {},
      toWelcome: false,
      campaign: '',
      accepted_home_publishing_agreement: false,
      user_id: null,
      submitSearchHome: false
    };
    this.setTypeUserSelected = this.setTypeUserSelected.bind(this);
    this.onRedirect = this.onRedirect.bind(this);
  }

  componentDidMount() {
    if (!this.props.status) {
      CurrentUser.getCurrent();
    }
    window.scrollTo(0, 0);
  }

  setTypeUserSelected = (typeUserSelected: any) => {
    this.setState({ typeUserSelected: typeUserSelected });
  };

  componentWillMount = () => {
    let keyParam = 'campaign';
    let searchParams = new URLSearchParams(this.props.location.search);
    let hasCampaign = searchParams.has(keyParam);
    localStorage.setItem('isCampaign', hasCampaign);

    if (hasCampaign) {
      let campaign = searchParams.get(keyParam);
      CampaignActions.getMarketingCampaigns(campaign);
    }
  };

  componentWillUnmount() {
    this.context.showNavegationBar();
    this.context.hideLoadingProcessView();
  }

  onRedirect = (): void => {
    const { home_id, utm_medium, campaign } = queryString.parse(
      this.props.location.search
    );
    if (home_id) {
      HomeApplicationActions.createHomeApplication(
        {
          home_application: {
            home_id,
            utm_medium,
            campaign
          }
        },
        () => {
          const home_app = HomeApplicationStore.getHomeApplication();
          this.props.history.push(
            `/inquilino/aplicaciones/${home_app.id}/editar/aplicar`
          );
        }
      );
    } else {
      this.setState({
        toWelcome: true
      });
    }
  };

  validateUser = () => {
    if (this.props.status) {
      this.validationTenant();
    } else {
      this.validationOwner();
    }
  };

  validationTenant = () => {
    if (this.context.currentUser.authenticated) {
      this.onRedirect();
    }
  };

  validationOwner = () => {
    if (this.context.currentUser.accepted_home_publishing_agreement) {
      if (this.context.currentUser.authenticated) {
        this.onRedirect();
      }
    }
  };

  onClickSearchHome = () => {
    this.setState({ isSubmitSearchHome: true });
  };

  setLeftSide = (): any => {
    const { home_id, utm_medium, campaign } = queryString.parse(
      this.props.location.search
    );
    let path = '';
    if (home_id || utm_medium || campaign) {
      path = this.props.location.search;
    }

    if (this.props.status) {
      return (
        <StyledLeftSide>
          <div>
            <View
              status={this.props.status}
              sizeContainer={'300px'}
              defaultSign={true}
              handleRedirect={this.onRedirect}
            />
            <DivLabel>
              <Label>
                ¿Ya tienes cuenta?,{' '}
                <StyledLink
                  to={{
                    pathname: '/autenticacion',
                    search: path
                  }}
                >
                  inicia sesión
                </StyledLink>{' '}
                en Homie.
              </Label>
            </DivLabel>
          </div>
        </StyledLeftSide>
      );
    }
    return (
      <StyledLeftSide>
        <div>
          <View
            status={this.props.status}
            sizeContainer={'300px'}
            defaultSign={true}
            handleRedirect={this.onRedirect}
            hideButtonSubmitHome={true}
          />
          <DivLabel>
            <Label>
              ¿Ya tienes cuenta?,{' '}
              <StyledLink
                to={{
                  pathname: '/autenticacion',
                  search: path
                }}
              >
                inicia sesión
              </StyledLink>{' '}
              en Homie.
            </Label>
          </DivLabel>
        </div>
      </StyledLeftSide>
    );
  };

  setRigthSide = (): any => {
    return (
      <RightSide>
        <img className="image-cover" src={Auth.sign_up} />
      </RightSide>
    );
  };

  showLogo = (): any => {
    if (this.props.status) return null;

    return (
      <WrapperLogo>
        <ContainerLogo>
          <Logo />
        </ContainerLogo>
      </WrapperLogo>
    );
  };

  isTenant = () => {
    return this.state.toWelcome && this.props.status;
  };

  isOwner = () => {
    return this.state.toWelcome && !this.props.status;
  };

  redirect = () => {
    const { currentUser } = this.context;

    if (currentUser.id === null) return;

    if (!this.props.status) {
      window.location.href = '/propietario/registra-tu-inmueble';
      return;
    }

    const search = this.props?.location?.search;
    const location = search.includes('return_to')
      ? search.split('return_to=')[1]
      : '/usuario/bienvenido';
    const path = currentUser.has_rented_active_or_started_home
      ? '/inquilino/pagos/rentas'
      : location;

    this.props.history.replace(path);
    return;
  };

  render() {
    this.redirect();
    return (
      <StyledWrapper isPadding={this.props.status}>
        <StyledContainer>
          {this.setLeftSide()}
          {this.setRigthSide()}
        </StyledContainer>
      </StyledWrapper>
    );
  }
}
Index.contextType = HomieContext;
export default withRouter(Index);
